/// <amd-module name="VSSUI/Components/FocusOrMouseWithin/FocusOrMouseWithin" />
import * as React from "react";

import { IFocusWithin, FocusWithin } from "VSSUI/FocusWithin";
import { IFocusOrMouseWithinProps } from "./FocusOrMouseWithin.Props";
import { IMouseWithin, MouseWithin, IMouseWithinStatus } from "VSSUI/MouseWithin";

export class FocusOrMouseWithin extends React.Component<IFocusOrMouseWithinProps> implements IFocusWithin, IMouseWithin {
    private mouseWithinRef = React.createRef<MouseWithin>();
    private focusWithinRef = React.createRef<FocusWithin>();

    public render(): JSX.Element {
        const { onMouseEnter, onMouseLeave, onFocus, onBlur } = this.props;
        let children: ((props: any) => JSX.Element) | JSX.Element;

        return (
            <MouseWithin ref={this.mouseWithinRef} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                {(mouseWithinStatus: IMouseWithinStatus) => {
                    if (typeof this.props.children === "function") {
                        children = (props: any) => {
                            return (this.props.children as (props: any) => JSX.Element)({ ...props, ...mouseWithinStatus });
                        };
                    } else {
                        const child = React.Children.only(this.props.children) as React.DetailedReactHTMLElement<any, HTMLElement>;
                        children = React.cloneElement(child, { ...child.props, ...mouseWithinStatus }, child.props.children);
                    }
                    return (
                        <FocusWithin onFocus={onFocus} onBlur={onBlur} ref={this.focusWithinRef}>
                            {children}
                        </FocusWithin>
                    );
                }}
            </MouseWithin>
        );
    }

    public hasFocus = (): boolean => {
        return !!this.focusWithinRef.current && this.focusWithinRef.current.hasFocus();
    };

    public hasMouse = (): boolean => {
        return !!this.mouseWithinRef.current && this.mouseWithinRef.current.hasMouse();
    };
}
